export default __webpack_public_path__ + "static/media/usuario.6d65a298.svg";